<template>
  <el-row class="variants">
    <el-col>
      <rest-list
        :payload="variantDataEndpoint"
        @dataLoaded="setVariantData($event)"
        ref="list"
      >
        <template v-if="variantData[0]">
          <rest-list-column
            prop="fields.id"
            :title="$t('CampaignOverview_Table_VariantName')"
            :sortable="false"
            :filter-input="false"
            :fixed="true"
            :width="variantWidth"
            :min-width="200"
          >
            <template v-if="row.fields.title" slot-scope="{ row }">
              <i v-if="row.fields.id === 'W'" class="el-icon-trophy" />
              <span v-else>{{ row.fields.id }}</span> –
              {{ row.fields.title }}
              <i
                v-if="parseInt(row.fields.winner)"
                class="winner el-icon-trophy"
              />
            </template>
          </rest-list-column>
          <rest-list-column
            v-if="model.custom_variant_share"
            prop="fields.split_percentage"
            :title="$t('CampaignOverview_VariantSplit_Percentage')"
            :sortable="false"
            :filter-input="false"
            :fixed="true"
            :width="variantWidth"
            :min-width="200"
          >
            <template v-slot="scope">
              {{ scope.row.fields.split_percentage }}
            </template>
          </rest-list-column>
          <rest-metric-group
            v-for="(metricGroup, metricIndex) in variantData[0].metricGroups"
            :key="metricIndex"
            :metric-group="metricGroup"
            :prop="'metricGroups[' + metricIndex + ']'"
            :sortable="false"
            :width="metricIndex ? 120 : 200"
          />
        </template>
      </rest-list>
    </el-col>
  </el-row>
</template>

<script>
import { projectEndpoint } from '@/core/helpers'
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestMetricGroup from '@/common/components/rest/RestMetricGroup'
import { mapGetters } from 'vuex'

export default {
  name: 'WorkflowVariantsTable',
  components: {
    RestMetricGroup,
    RestListColumn,
    RestList
  },
  props: {
    analyticsDateRange: {
      type: Object,
      required: true
    },

    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return { variantData: [] }
  },

  methods: {
    setVariantData(data) {
      this.variantData = [...data]
    }
  },

  computed: {
    ...mapGetters(['userConfig']),
    variantWidth() {
      let width = null
      this.variantData.forEach(row => {
        if (row.fields.title.length) {
          width = 250
        }
      })
      return width
    },
    variantDataEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `campaigns/${this.$route.query.id}/analytics/variants`,
        params: {
          date_from: this.analyticsDateRange.date_from,
          date_to: this.analyticsDateRange.date_to
        }
      })
    }
  }
}
</script>

<style scoped>
>>> .el-table thead.is-group th {
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/analytics/WorkflowVariantsTable.vue